/**
 * Returns a new AutocompleteService instance if Google Maps is loaded.
 */
export function getAutocompleteService(
  isLoaded: boolean
): google.maps.places.AutocompleteService | null {
  if (!isLoaded || typeof window === "undefined") return null;
  return new google.maps.places.AutocompleteService();
}

/**
 * Returns a new PlacesService instance if Google Maps is loaded.
 */
export function getPlacesService(
  isLoaded: boolean
): google.maps.places.PlacesService | null {
  if (!isLoaded || typeof window === "undefined") return null;
  return new google.maps.places.PlacesService(document.createElement("div"));
}

/**
 * Extracts the city name from a PlaceResult object.
 */
export function getCityFromPlace(
  place: google.maps.places.PlaceResult
): string {
  const address = place.address_components || [];
  return (
    address.find((c: google.maps.GeocoderAddressComponent) =>
      c.types.includes("locality")
    )?.long_name || ""
  );
}

/**
 * Extracts the country name from a PlaceResult object.
 */
export function getCountryFromPlace(
  place: google.maps.places.PlaceResult
): string {
  if (!place.address_components) return "";

  const countryComponent = place.address_components.find((component) =>
    component.types.includes("country")
  );

  return countryComponent?.long_name || "";
}
